import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { PRICE, PRICE_BEFORE, PRODUCT_IMAGE, offerIncludes, offerRows } from '../data/piano';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-240" data-mp="1mm7husnl15db">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-241" data-mp="1hpqrdrswuex2">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-242" data-mp="tzwexbci6sdc">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-243" data-mp="ozryflblhxn4">
            Discover the complete <em className="text-red-300" data-id="element-244" data-mp="13wrb3nlb0gog">PIANO READY™</em> package
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-245" data-mp="13uohktky05ez">
            Your whole piano studio year – already planned. Get started in 5 minutes.
          </p>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-246" data-mp="2feano6krxvzo" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-247" data-mp="pkh5x9amssf5">
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-248" data-mp="uhqrueytaly8">The complete package includes</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-249" data-mp="ziwognvletd1">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-250" data-mp="13j72mntjgq2z">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-251" data-mp="6usgfvpju476">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-252" data-mp="btc35ybyvk0l" />
                </span>
                <span data-id="element-253" data-mp="fsb4l8yhoyna">
                  <span className="block font-medium leading-snug" data-id="element-254" data-mp="kl4ai05p2d0y">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-255" data-mp="kmyw7gosi963">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-256" data-mp="3o8wgoymf47um">
            <p className="text-sm font-medium text-slate-900/70 sm:pb-2" data-id="element-257" data-mp="qgnqgd7e0yi4">Introductory price <s className="ml-1 text-slate-900/50" data-id="element-258" data-mp="qejow1wyobl0">{PRICE_BEFORE}</s></p>
            <p className="font-serif text-7xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-259" data-mp="1548tk749ixq1">
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-260" data-mp="cgmpyyv1bt36">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-261" data-mp="7ibfqn0tvgkf" />
            One-time payment. No subscription.
          </p>

          <CtaButton label="Get the complete package now" className="mt-8 w-full" data-id="element-262" data-mp="licf1y1g2fxs" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-263" data-mp="hewlxbol2xpu">
            {offerIncludes.map(item => <li key={item} data-id="element-264" data-mp="1wuwt5eqafv1l">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}